import { useCallback } from "react"
import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast } from "@hooks"
import { commonFiltersValue } from "@signals"
import { adminNewListedDetailsData, adminNewListedTableData, retailerSelected, filteredRetailers } from "../@signals"


export default function useAdminNewListedSubmits() {
	const { showToast } = useToast()
	const adminNewListedIsEmpty = useSignal(false)

	const handleSubmitFilters = useCallback(values => {
		adminNewListedIsEmpty.value = false
		
		return postSubmit(`${WEBBACK_V2_API}/admin/new-listed/raw-data`, values).then(({ table, detail }) => {
			if (!table.length) adminNewListedIsEmpty.value = true
			else {
				adminNewListedTableData.value = table
				adminNewListedDetailsData.value = detail
				filteredRetailers.value = commonFiltersValue.value.retailer
				retailerSelected.value = commonFiltersValue.value.retailer
			}
		}).catch(() => {
			showToast.error()
		})
	}, [])

	return { adminNewListedIsEmpty, handleSubmitFilters }
}